import React from 'react'
import { LazyLoadImage } from "react-lazy-load-image-component";
import Floor13K3 from './Components/Floor13K3'
import Floor12K3 from './Components/Floor12K3'
import Floor11K3 from './Components/Floor11K3'
import Floor10K3 from './Components/Floor10K3'
import Floor9K3 from './Components/Floor9K3'
import Floor8K3 from './Components/Floor8K3'
import Floor7K3 from './Components/Floor7K3'
import Floor6K3 from './Components/Floor6K3'
import Floor5K3 from './Components/Floor5K3'
import Floor4K3 from './Components/Floor4K3'
import Floor3K3 from './Components/Floor3K3'
import Floor2K3 from './Components/Floor2K3'
import Floor1K3 from './Components/Floor1K3'
import Floor13K4 from './Components/Floor13K4'
import Floor12K4 from './Components/Floor12K4'
import Floor11K4 from './Components/Floor11K4'
import Floor10K4 from './Components/Floor10K4'
import Floor9K4 from './Components/Floor9K4'
import Floor8K4 from './Components/Floor8K4'
import Floor7K4 from './Components/Floor7K4'
import Floor6K4 from './Components/Floor6K4'
import Floor5K4 from './Components/Floor5K4'
import Floor4K4 from './Components/Floor4K4'
import Floor3K4 from './Components/Floor3K4'
import Floor2K4 from './Components/Floor2K4'
import Floor1K4 from './Components/Floor1K4'

function ClickFloor34() {
  return (
  <div className='w-[100vw] relative mb-40  mt-40 '>
      <div className='w-[100vw] relative '>
      <LazyLoadImage className='w-[100vw] top-[0vw] right-[0vw] relative ' src="/images/click/clean-images/click-floors-4-3.jpg" alt="" />
     
      <Floor13K3 />
      <Floor12K3 />
      <Floor11K3 />
      <Floor10K3 />
      <Floor9K3 />
      <Floor8K3 />
      <Floor7K3 />
      <Floor6K3 />
      <Floor5K3 />
      <Floor4K3 />
      <Floor3K3 />
      <Floor2K3 />
      <Floor1K3 />
      <Floor13K4 />
      <Floor12K4 />
      <Floor11K4 />
      <Floor10K4 />
      <Floor9K4 />
      <Floor8K4 />
      <Floor7K4 />
      <Floor6K4 />
      <Floor5K4 />
      <Floor4K4 />
      <Floor3K4 />
      <Floor2K4 />
      <Floor1K4 />
    </div>
  </div>
  )
}

export default ClickFloor34

